import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Head from '@/components/base/Head';
import { categories, articles } from '@/mocks/data';

const categoryHeroImages: Record<string, string> = {
  'yule-mingxing': 'https://readdy.ai/api/search-image?query=Red%20carpet%20Hollywood%20event%20with%20crowds%20and%20flashing%20cameras%2C%20warm%20golden%20lighting%2C%20glamorous%20atmosphere%2C%20cinematic%20wide%20shot%2C%20editorial%20quality%2C%20celebrity%20culture%20vibe%2C%20luxurious%20red%20and%20gold%20aesthetic&width=1600&height=500&seq=hero-cat-yule&orientation=landscape',
  'wanghong-zhubo': 'https://readdy.ai/api/search-image?query=Modern%20streaming%20studio%20with%20multiple%20screens%20and%20ring%20lights%2C%20professional%20broadcasting%20setup%2C%20warm%20neon%20accents%2C%20social%20media%20influencer%20aesthetic%2C%20cinematic%20wide%20angle%2C%20golden%20ambient%20lighting&width=1600&height=500&seq=hero-cat-wanghong&orientation=landscape',
  'shehui-redian': 'https://readdy.ai/api/search-image?query=City%20skyline%20at%20sunset%20with%20news%20headlines%20projected%2C%20dramatic%20sky%2C%20journalism%20theme%2C%20warm%20golden%20hour%20lighting%2C%20urban%20landscape%2C%20editorial%20quality%2C%20breaking%20news%20aesthetic&width=1600&height=500&seq=hero-cat-shehui&orientation=landscape',
  'dianshi-zongyi': 'https://readdy.ai/api/search-image?query=TV%20show%20production%20stage%20with%20dramatic%20lighting%20rigs%20and%20cameras%2C%20entertainment%20studio%20set%2C%20warm%20cinematic%20atmosphere%2C%20golden%20spotlights%2C%20variety%20show%20vibe%2C%20professional%20broadcast%20equipment&width=1600&height=500&seq=hero-cat-zongyi&orientation=landscape',
  'dujia-bagua': 'https://readdy.ai/api/search-image?query=Detective%20theme%20with%20vintage%20documents%20and%20magnifying%20glass%2C%20mysterious%20atmosphere%2C%20warm%20amber%20lighting%2C%20film%20noir%20style%2C%20investigative%20journalism%20aesthetic%2C%20dark%20wood%20desk%2C%20dramatic%20shadows&width=1600&height=500&seq=hero-cat-dujia&orientation=landscape',
  'hulianwang': 'https://readdy.ai/api/search-image?query=Futuristic%20server%20room%20with%20blinking%20lights%2C%20tech%20environment%2C%20warm%20amber%20and%20soft%20blue%20accent%20lighting%2C%20data%20center%20aesthetic%2C%20cinematic%20wide%20shot%2C%20cyber%20vibe%2C%20professional%20corporate%20atmosphere&width=1600&height=500&seq=hero-cat-internet&orientation=landscape',
};

const categoryArticleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20luxurious%20hotel%20entrance%20at%20night%20with%20paparazzi-style%20photography%2C%20dramatic%20lighting%2C%20blurred%20figure%20walking%20in%2C%20cinematic%20composition%2C%20warm%20amber%20street%20lights%2C%20mysterious%20atmosphere&width=800&height=500&seq=cat-art-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=A%20modern%20live%20streaming%20studio%20setup%20with%20professional%20lighting%2C%20smartphone%20on%20tripod%2C%20beauty%20products%20on%20table%2C%20warm%20indoor%20lighting%2C%20documentary%20style&width=800&height=500&seq=cat-art-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20showing%20social%20media%20profiles%2C%20soft%20moody%20lighting%2C%20melancholy%20atmosphere%2C%20editorial%20photography%2C%20warm%20desaturated%20tones&width=800&height=500&seq=cat-art-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20TV%20studio%20with%20production%20equipment%2C%20lighting%20rigs%2C%20empty%20stage%2C%20dramatic%20spotlight%2C%20cinematic%20style&width=800&height=500&seq=cat-art-04&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Upscale%20Chinese%20restaurant%20private%20dining%20room%2C%20round%20table%20with%20dishes%2C%20dim%20warm%20lighting%2C%20suspenseful%20atmosphere%2C%20cinematic%20photography&width=800&height=500&seq=cat-art-05&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Split%20composition%20before%20and%20after%20beauty%20concept%2C%20soft%20lighting%2C%20elegant%20dramatic%20comparison%2C%20editorial%20magazine%20style%2C%20warm%20peachy%20tones&width=800&height=500&seq=cat-art-06&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Modern%20office%20workspace%20with%20multiple%20computer%20screens%2C%20social%20media%20dashboards%2C%20dim%20desk%20lamp%2C%20moody%20atmosphere%2C%20late%20night%20working%20scene&width=800&height=500&seq=cat-art-07&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=Billboard%20being%20changed%20with%20brand%20advertisement%2C%20workers%20on%20ladder%2C%20urban%20street%2C%20dramatic%20sky%2C%20editorial%20photography%2C%20warm%20sunset%20lighting&width=800&height=500&seq=cat-art-08&orientation=landscape',
  9: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20bright%20stage%20lights%2C%20empty%20chairs%2C%20microphone%20on%20floor%2C%20dramatic%20tension%2C%20cinematic%20lighting%20contrast&width=800&height=500&seq=cat-art-09&orientation=landscape',
  10: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20at%20dusk%2C%20dramatic%20sky%2C%20somber%20mood%2C%20reflective%20glass%2C%20urban%20landscape%2C%20editorial%20journalism&width=800&height=500&seq=cat-art-10&orientation=landscape',
  11: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20set%20with%20traditional%20costumes%2C%20behind%20scenes%20chaos%2C%20dramatic%20confrontation%2C%20cinematic%20lighting%2C%20warm%20sunset%20backlight&width=800&height=500&seq=cat-art-11&orientation=landscape',
  12: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20video%20editing%20timeline%20with%20cuts%2C%20dramatic%20reveal%2C%20moody%20lighting%2C%20modern%20digital%20aesthetic%2C%20warm%20amber%20and%20cool%20contrast&width=800&height=500&seq=cat-art-12&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-20 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-heading text-foreground-900">分类不存在</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600">
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const categoryArticles = articles.filter((a) => a.categorySlug === slug);
  const canonicalUrl = `/category/${slug}`;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 黑料吃瓜网`,
    description: category.description,
    url: canonicalUrl,
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料吃瓜网',
      url: '/',
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
      { '@type': 'ListItem', position: 2, name: category.name, item: canonicalUrl },
    ],
  };

  return (
    <>
      <Head
        title={`${category.name} - 黑料吃瓜网 | ${category.description}`}
        description={`黑料吃瓜网${category.name}频道，${category.description}。每日更新最新${category.name}相关爆料，免费吃瓜第一站。`}
        keywords={`${category.name},黑料吃瓜网,吃瓜网,${category.name}八卦,热点爆料`}
        canonicalUrl={canonicalUrl}
        ogTitle={`${category.name} - 黑料吃瓜网`}
        ogDescription={category.description}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <Navbar />

      <main>
        <header className="relative w-full h-[350px] md:h-[420px] overflow-hidden">
          <img
            src={categoryHeroImages[slug] || ''}
            alt={category.name}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
            <h1 className="text-3xl md:text-5xl font-heading text-white">{category.name}</h1>
            <p className="mt-4 text-white/80 text-base max-w-xl text-center">
              {category.description}
            </p>
          </div>
        </header>

        <nav className="bg-background-50 border-b border-background-200/60">
          <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-3">
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">{category.name}</span>
            </div>
          </div>
        </nav>

        <section className="py-12 md:py-20 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-8">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-8">
              {category.name}最新爆料
            </h2>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {categoryArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/60 transition-all duration-300 hover:scale-[1.02]"
                  >
                    <div className="relative h-52 overflow-hidden">
                      <img
                        src={categoryArticleImages[article.id] || ''}
                        alt={article.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-5">
                      <h3 className="text-lg font-heading text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/60">
                        <div className="flex items-center gap-3 text-xs text-foreground-500">
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line"></i>
                            {article.views > 10000
                              ? `${(article.views / 10000).toFixed(1)}万`
                              : article.views}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-chat-3-line"></i>
                            {article.comments}
                          </span>
                        </div>
                        <span className="text-xs text-foreground-400">{article.publishedAt}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">暂无相关内容，敬请期待</p>
                <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600">
                  返回首页查看更多
                </Link>
              </div>
            )}
          </div>
        </section>

        <section className="relative w-full py-20 md:py-28 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Colorful%20abstract%20collage%20of%20entertainment%20and%20news%20elements%2C%20warm%20golden%20and%20amber%20gradient%2C%20cinematic%20wide%20composition%2C%20dramatic%20lighting%2C%20modern%20editorial%20style%2C%20dynamic%20atmosphere&width=1600&height=600&seq=cta-cat-cross&orientation=landscape"
            alt="换种口味继续吃"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40"></div>
          <div className="relative max-w-[1280px] mx-auto px-4 md:px-8">
            <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
              <div>
                <h2 className="text-3xl md:text-4xl font-heading text-white">换种口味继续吃</h2>
                <Link
                  to="/category/shehui-redian"
                  className="mt-6 inline-flex items-center gap-3 px-8 py-3.5 bg-white text-foreground-900 rounded-full text-sm font-medium hover:bg-foreground-50 transition-colors whitespace-nowrap"
                >
                  探索更多分类
                  <span className="w-6 h-6 bg-foreground-950 rounded-full flex items-center justify-center">
                    <i className="ri-arrow-right-line text-white text-xs"></i>
                  </span>
                </Link>
              </div>
              <p className="text-white/80 text-base max-w-md leading-relaxed">
                吃瓜不挑食，多个分类任你选。换个频道继续挖掘更多不为人知的秘密
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}